import { formatCurrency } from '@coingecko/cryptoformat';

// 一个向下取整到 precision 的函数。
// console.log(floorToN(3.14159, 2)); // 输出：3.14
// console.log(floorToN(9.8765, 3)); // 输出：9.876
// console.log(floorToN(5.12345, 1)); // 输出：5.1
export function floorToN(num: number, n = 2): number {
  // if num not a number, return -;
  if (isNaN(num)) return;

  const multiplier = Math.pow(10, n);
  return Math.floor(num * multiplier) / multiplier;
}
export function roundToN(num: number, n = 2): number {
  // if num not a number, return -;
  if (isNaN(num)) return;

  const multiplier = Math.pow(10, n);
  return Math.round(num * multiplier) / multiplier;
}

//获取有效数字  0.001000  -> 0.001
function removeTrailingZeros(inputString) {
  return inputString.replace(/\.?0+$/, '');
}

export function floorToNString(num: number, n = 2): string {
  const result = floorToN(num, n);
  return removeTrailingZeros(result.toFixed(n));
}

// 随机值：0.9615 ~ &
export const randomX = () => {
  const x = Math.random() * (1 - -0.04) - 0.04;
  const X = floorToN(1 / (1 - x));
  return X <= 1 ? 1.0 : X;
};

// 爆点时间计算
export const exponentialTimeFunction = (x: number): number =>
  Math.log2(x) / 0.09;

// 根据 randomX 获得爆点时间
export const getExponentialTime = () => {
  const x = randomX();
  const time = exponentialTimeFunction(x);
  return Math.max(1, floorToN(time));
};

type ArrayElement = number | number[];

/**
 *
 * const input = [1, 2, 3, 4, 5, 3, 6, 7, 8, 9, 10];
 * const output = removeNonIncreasingElements(input);
 * console.log(output); // 输出: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
 *
 * @param arr
 * @param compareIndex
 * @param isDecreasing
 * @returns
 */
export function removeNonIncreasingElements(
  arr: ArrayElement[],
  compareIndex: 0 | 1 = 1,
  isDecreasing = false,
): ArrayElement[] {
  const result: ArrayElement[] = [];
  let prev: number | null = null;

  for (const elem of arr) {
    const currentValue = Array.isArray(elem) ? elem[compareIndex] : elem;
    if (
      prev === null ||
      (isDecreasing ? currentValue < prev : currentValue > prev)
    ) {
      result.push(elem);
      prev = currentValue;
    }
  }

  return result;
}

export const map = (value, in_min, in_max, out_min, out_max) => {
  return ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
};

export const getBorderColor = (value: number) => {
  if (value <= 1) {
    return '#F79601';
  } else if (value < 2) {
    //1.01-1.99
    return '#D80027';
  } else if (value < 10) {
    //2.00-9.99
    return '#26A17B';
  } else if (value < 30) {
    //10.00-29.99
    return '#6267BB';
  } else if (value < 100) {
    //30.00-100.00
    return '#FBB709';
  } else {
    return '#FBB709';
  }
};

//calc bg color by value
export const getBgColor = (value: number, opacity = 0.2) => {
  if (value <= 1) {
    return `rgba(247, 150, 1, ${opacity})`;
  } else if (value < 2) {
    //1.01-1.99
    return `rgba(244,67,54, ${opacity})`;
  } else if (value < 10) {
    //2.00-9.99
    return `rgba(0, 153, 255, ${opacity})`;
  } else if (value < 30) {
    //10.00-29.99
    return `rgba(98, 103, 187, ${opacity})`;
  } else if (value < 100) {
    //30.00-100.00
    return `rgba(251, 183, 9, ${opacity})`;
  } else {
    return '#694f12';
  }
};
